import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class PropertyCollectionCategoryActivity extends Component {
	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/RealEstate/PropertyCollectionCategory/PropertyCollectionCategoryBrowser")
	}

	render() {
		return (
			<Activity 
				name="CollectionCategory"
				RenderedComponent={this.RenderedComponent}
				context="CollectionCategory"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(PropertyCollectionCategoryActivity)
